<template>
<header id="masthead" role="banner"><div class="site-branding"><router-link to="/" id="logo">&nbsp;</router-link><h1>Executive Advantage Planner</h1>
  <button id="menu-toggle">&nbsp;</button>
 <nav id="user_status"><ul><li><a @click="doLogout()" class="login">Log Out</a></li></ul></nav>
 <SiteNav></SiteNav>
  </div>
  </header>
</template>
<script>
import { mapActions } from 'vuex'
import SiteNav from '@/components/SiteNav'

export default {
  components: {
      SiteNav
  },
  methods: {
    ...mapActions('loginStore', ['logout']),
    doLogout(){
      this.logout({}, {rootStore:true});
    }
  }
}
</script>